export enum ETheme {
  "light",
  "dark",
  "contrastLight",
  "contrastDark"
}
